<template>
  <div class="do-group">
    <label class="d-label">Hvilken ansættelse skal det tælle som?</label><br>
    <select class="do-select" :value="selectedEmploymentTitle" @change="onChange($event.target.value)">
      <option disabled value="">Vælg ansættelse</option>
      <option v-for="employmentsType in employmentToSelectForRules" :value="employmentsType">
        {{ employmentsType }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    subjectType: {
      default: '_extra_time_if_shorter_than_'
    },
    propSelectedEmploymentTypeId: {
      default: ''
    }
  },
  data () {
    return {
      selectedEmploymentTitle: this.propSelectedEmploymentTypeId
    }
  },
  computed: {
    employmentToSelectForRules () {
      if (this.subjectType === '_extra_time_at_start_of_day_') {
        return this.$store.getters.employmentToSelectForRules.filter(title => title !== '*Stillingen fra lektionen før*')
      }
      if (this.subjectType === '_extra_time_if_shorter_than_') {
        return this.$store.getters.employmentToSelectForRules.filter(title => title !== '*Stillingen fra lektionen efter*')
      }
      return this.$store.getters.employmentToSelectForRules
    }
  },
  watch: {
    propSelectedEmploymentTypeId (newVal) {
      // Opdaterer selectedEmploymentTitle, når prop'en ændrer sig
      this.selectedEmploymentTitle = newVal
    }
  },
  methods: {
    onChange (val) {
      this.selectedEmploymentTitle = val
      this.$emit('change', val)
    }
  },
  mounted () {
    this.selectedEmploymentTitle = this.propSelectedEmploymentTypeId
  }
}
</script>


<style scoped>

.do-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do-select {
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border-radius: 4px;
  background-color: #fff;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// SalaryRulesRule.vue?6a149cae